import { modifier } from 'ember-modifier';

export default modifier(() => { }, { eager: false });
